import { RatioBox } from '@/components/Atoms/RatioBox/RatioBox';
import { ResponsiveImage } from '@/components/Atoms/ResponsiveImage/ResponsiveImage';
import { VideoIndicator } from '@/components/Atoms/VideoIndicator/VideoIndicator';
import type { ResponsiveImageHints } from '@/services/ResponsiveImageHints';
import type { ComponentProps } from 'react';
import type { FCl } from 'react-fc';

/**
 * An image for a media card, with a badge overlay if required
 */
export const MediaCardImage: FCl<IMediaCardProps> = ({
    className,
    imageHints,
    url,
    durationSeconds,
    showPlayButton = false,
}) => (
    <RatioBox ratio={imageHints.displayRatio} className={className}>
        <ResponsiveImage src={url} sizeHints={imageHints} />
        {(showPlayButton || !!durationSeconds) && (
            <VideoIndicator
                css={`
                    position: absolute;
                    bottom: 0;
                    left: 0;
                `}
                durationSeconds={durationSeconds}
            />
        )}
    </RatioBox>
);

export interface IMediaCardProps {
    url: ComponentProps<typeof ResponsiveImage>['src'];
    imageHints: ResponsiveImageHints;
    showPlayButton?: boolean;
    durationSeconds?: number;
}
